import { cn } from "./lib/cn";

export interface AvatarProps {
  /** Baş harflerin türetildiği ad. */
  name: string;
  /**
   * Erişilebilir ad. Verilmezse avatar ekran okuyucudan GİZLENİR — yanında adın kendisi
   * yazıyorsa kullanıcı onu iki kez duymamalı.
   */
  label?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const BOYUTLAR: Record<NonNullable<AvatarProps["size"]>, string> = {
  sm: "size-6 text-[10px]",
  md: "size-8 text-xs",
  lg: "size-10 text-sm",
};

/**
 * Adın baş harfleri (CLOS-104 `[065]`).
 *
 * ⚠ **Türkçe büyük harf kuralı.** `toUpperCase()` "ilhan"ı "ILHAN" yapar ve baş harf "I"
 * çıkar; Türkçede doğrusu "İ". Yerel ayarsız bir dönüşüm, Türk kullanıcıların adını yanlış
 * yazan bir avatar üretirdi — ürünün bütün metinleri Türkçe olan bir uygulamada bu sessiz
 * bir kabalık olurdu.
 *
 * Ad boşsa soru işareti: boş bir daire kullanıcıya "bir şey mi eksik?" dedirtir, `?` ise
 * belirsizliği açıkça söyler.
 */
export function initials(name: string): string {
  const parcalar = name.trim().split(/\s+/).filter(Boolean);
  if (parcalar.length === 0) return "?";
  const ilk = parcalar[0]!;
  const son = parcalar[parcalar.length - 1]!;
  const harfler = parcalar.length === 1 ? [ilk[0]] : [ilk[0], son[0]];
  return harfler
    .filter((h): h is string => h !== undefined)
    .join("")
    .toLocaleUpperCase("tr");
}

/**
 * Baş harf avatarı.
 *
 * Görsel yükleme YOK: hesap profilinde bugün bir avatar alanı yok (`[017]`) ve olmayan bir
 * görseli beklemek, her açılışta boş bir kutu göstermek olurdu. Alan eklendiğinde bu
 * bileşen bir `src` varyantı kazanır — çağıranlar değişmez (kriter 5).
 */
export function Avatar({ name, label, size = "md", className }: AvatarProps) {
  return (
    <span
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : "true"}
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full bg-primary-soft font-semibold text-primary",
        BOYUTLAR[size],
        className,
      )}
    >
      {initials(name)}
    </span>
  );
}
